import type { IconSvgObject } from './types';

const EraserAddIcon: IconSvgObject = [
  ["path", { d: "M11 8V16M15 12H7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 6C2 4.89543 2.89543 4 4 4H15.8915C16.5811 4 17.222 4.35524 17.5875 4.94L21.3375 10.94C21.7428 11.5885 21.7428 12.4115 21.3375 13.06L17.5875 19.06C17.222 19.6448 16.5811 20 15.8915 20H4C2.89543 20 2 19.1046 2 18V6Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default EraserAddIcon;
